/* eslint-disable */
import React from 'react'
import Fade from 'react-reveal/Fade';
import { useTranslation } from "react-i18next";
import { Grid, Row, Col } from 'react-flexbox-grid'

import CardBox from '../../components/card-box'
import { TitleOne, TextBodyOne, BorderText } from '../../components/text'
import icGoodGive from '../../static/icons/ic-good-give.svg'
import icGoodWork from '../../static/icons/ic-good-work.svg'
import icGoodTechnic from '../../static/icons/ic-good-technic.svg'
import { Style } from './service-massage.styles'

const ServiceMassage = () => {
  const { t } = useTranslation();

  return (
    <Style id="service-massage">
      <Grid>
        <Row center="lg">
          <Col
            sm={12}
            xs={12}
            lg={8}
            className="column-fix-margin"
          >
            <TitleOne className="title-one" display="block" align="center">
              {t('pageServiceAcJakarta.part15')}
            </TitleOne>
            <div className="top-margin">
              <TextBodyOne className="title-body-one">
                {t('pageServiceAcJakarta.part16')}
              </TextBodyOne>
              <TextBodyOne className="title-body-one">
                {t('pageServiceAcJakarta.part17')}
              </TextBodyOne>
            </div>
            <div className="border">
              <Fade left>
                <BorderText background="linear-gradient(86deg, #ff8270, #e3eff9)"></BorderText>
              </Fade>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={4} xs={12} md={4} lg={4} className="bottom-margin">
            <CardBox
              color="#033260"
              border="#d7f1ff"
              image={icGoodGive}
              title={t('pageServiceAcJakarta.part18')}
              desc={t('pageServiceAcJakarta.part19')}
            ></CardBox>
          </Col>
          <Col sm={4} xs={12} md={4} lg={4} className="bottom-margin">
            <CardBox
              color="#033260"
              border="#d7f1ff"
              image={icGoodWork}
              title={t('pageServiceAcJakarta.part20')}
              desc={t('pageServiceAcJakarta.part21')}
            ></CardBox>
          </Col>
          <Col sm={4} xs={12} md={4} lg={4} className="bottom-margin">
            <CardBox
              color="#033260"
              border="#d7f1ff"
              image={icGoodTechnic}
              title={t('pageServiceAcJakarta.part22')}
              desc={t('pageServiceAcJakarta.part23')}
            ></CardBox>
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default ServiceMassage
